class HeaderSearchButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleSearchButtonClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleSearchButtonClick);
  }

  handleSearchButtonClick(event) {

    // scroll to top of page
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    // add style display block to main-header .header__top
    const headerTop = document.querySelector('main-header .header__top');
    if (headerTop) {
      headerTop.style.display = 'block';
      this.style.visibility = 'hidden';
    }
    
    // focus on search input field
    const searchInput = document.querySelector('.header__top input[name="q"]');
    if (searchInput) {
      searchInput.focus();
    }
  }
}

if (!customElements.get('header-search-button')) {
  customElements.define('header-search-button', HeaderSearchButton);
}

///////////////////////////////////////////////////////////////////////////////

class SizeSelectorMensWomens extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    this.mensButton = this.querySelector('button[data-mens-sizes]');
    this.womensButton = this.querySelector('button[data-womens-sizes]');
    this.sizeOptions = this.querySelectorAll('.product-variant__container .product-variant__item');
    
    this._boundMensClick = this.handleMensClick.bind(this);
    this._boundWomensClick = this.handleWomensClick.bind(this);

    this.mensButton.addEventListener('click', this._boundMensClick);
    this.womensButton.addEventListener('click', this._boundWomensClick);
  }

  disconnectedCallback() {
    this.mensButton.removeEventListener('click', this._boundMensClick);
    this.womensButton.removeEventListener('click', this._boundWomensClick);
  }

  handleMensClick(event) {
    if(this.dataset.filterSizes) { 
      const event = new Event('change', { bubbles: true });
      this.querySelector('input[value="M7 / W9"]').checked = true
      document.querySelector('product-variants').dispatchEvent(event)
    }
    
    this.mensButton.classList.add('selected');
    this.womensButton.classList.remove('selected');
    const selectedVariantDisplays = document.querySelectorAll(
    `[data-display-selected-variant-mens-womens]`
    );

    this.sizeOptions.forEach(option => {
      const label = option.querySelector('label');
      const input = option.querySelector('input');
      const actualValue = input.getAttribute('value') || '';
      const newDisplayValue = actualValue.split('/')[0].trim();
      
      if(this.dataset.filterSizes) { 
        label.textContent = newDisplayValue.replace('M','').replace('W','');
      } else {
        label.textContent = newDisplayValue;  
      }
      
      input.dataset.displayValue = newDisplayValue.replace("M", "Men's ");
      if (input.hasAttribute('data-selected') && selectedVariantDisplays.length > 0) {
        for (const displayText of selectedVariantDisplays) {
          displayText.textContent = newDisplayValue.replace("M", "Men's ");
        }
      }
      input.closest(".product-variant__item").dataset.sandalSize = newDisplayValue;
    });
    


  }

  handleWomensClick(event) {
    
    if(this.dataset.filterSizes) { 
      const event = new Event('change', { bubbles: true });
      this.querySelector('input[value="M4 / W6"]').checked = true
      document.querySelector('product-variants').dispatchEvent(event)
    }
    
    this.womensButton.classList.add('selected');
    this.mensButton.classList.remove('selected');
    const selectedVariantDisplays = document.querySelectorAll(
    `[data-display-selected-variant-mens-womens]`
    );

    this.sizeOptions.forEach(option => {
      const label = option.querySelector('label');
      const input = option.querySelector('input');

      const actualValue = input.getAttribute('value') || '';
      const newDisplayValue = actualValue.split('/')[1].trim();

      if(this.dataset.filterSizes) { 
        label.textContent = newDisplayValue.replace('M','').replace('W','');
      } else {
        label.textContent = newDisplayValue;  
      }
      input.dataset.displayValue = newDisplayValue.replace("W", "Women's ");

      if (input.hasAttribute('data-selected') && selectedVariantDisplays.length > 0) {
        for (const displayText of selectedVariantDisplays) {
          displayText.textContent = newDisplayValue.replace("W", "Women's ");
        }
      }
      input.closest(".product-variant__item").dataset.sandalSize = newDisplayValue;

    });

  }
}

if (!customElements.get('size-selector-mens-womens')) {
  customElements.define('size-selector-mens-womens', SizeSelectorMensWomens);
}

///////////////////////////////////////////////////////////////////////////////

class ProductPageOrderDeadline extends HTMLElement {
    static STORE_TIME_ZONE = 'America/Los_Angeles';

    constructor() {
        super();
        
    }

    connectedCallback() {
        this.cutoffDateElement = this.querySelector('div[data-order-cutoff-date]');
        this.shipDateElement = this.querySelector('div[data-order-ships-date]');
        this.cutoffDaysInput = this.cutoffDateElement.getAttribute('data-cutoff-days');
        this.shipDaysInput = this.shipDateElement.getAttribute('data-ship-days');
        
        this.cutoffDayOptions = JSON.parse(this.cutoffDaysInput);
        this.shipDayOptions = JSON.parse(this.shipDaysInput);
        
        this.settingIndex = 0;

        this.cutoffDate = null;
        this.timeToNextCutoffDate = null;
        this.shipDate = null;
        this.renderedCutoffInfoString = '';
        this.renderedShipDateString = '';

        this.setCutoffAndShipDates(this.cutoffDayOptions, this.shipDayOptions);
        this.renderHtmlElements(this.renderedCutoffInfoString, this.renderedShipDateString);
        this.setCartAttribute(this.renderedShipDateString.replace('Ships ', ''));
    }

    setCutoffAndShipDates(cutoffDayOptions, shipDayOptions) {
        const now = new Date();
        const cutoffDates = cutoffDayOptions
            .map((option, index) => ({
                index,
                weekday: Number(option[0]),
                hour: Number(option[1])
            }))
            .filter(option => Number.isInteger(option.weekday) && option.weekday >= 1 && option.weekday <= 7)
            .map(option => ({
                index: option.index,
                date: this.getNextStoreWeekday(option.weekday, option.hour, now)
            }))
            .sort((a, b) => a.date - b.date);

        if (!cutoffDates.length) {
            this.renderedCutoffInfoString = '';
            this.renderedShipDateString = '';
            return;
        }

        this.settingIndex = cutoffDates[0].index;
        this.cutoffDate = cutoffDates[0].date;

        const remainingMinutes = Math.max(0, Math.floor((this.cutoffDate - now) / 60000));
        this.timeToNextCutoffDate = {
            days: Math.floor(remainingMinutes / 1440),
            hours: Math.floor((remainingMinutes % 1440) / 60),
            minutes: remainingMinutes % 60
        };

        const shipOption = shipDayOptions[this.settingIndex];
        const shipWeekday = Number(shipOption[0]);
        const shipWeekOffset = Math.max(0, Number(shipOption[1]) || 0);

        this.shipDate = this.getStoreWeekdayInCurrentWeek(shipWeekday, 0, now);
        this.shipDate = this.addStoreCalendarDays(this.shipDate, shipWeekOffset * 7);

        // If the configured shipping date is before the selected cutoff, use the next week.
        if (this.shipDate < this.cutoffDate) {
            this.shipDate = this.addStoreCalendarDays(this.shipDate, 7);
        }

        // Get cutoff info rendered string
        this.renderedCutoffInfoString = `Order within ${this.timeToNextCutoffDate.days} Days ${this.timeToNextCutoffDate.hours} Hrs ${this.timeToNextCutoffDate.minutes} Mins`;

        // Get ship date rendered string
        const getDateSuffix = (date)=>{
            if (date > 3 && date < 21) return "th";
            switch(date % 10){
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        };

        const shipDateParts = this.getStoreDateParts(this.shipDate);
        const shipWeekdayName = new Intl.DateTimeFormat('en-US', {
            timeZone: ProductPageOrderDeadline.STORE_TIME_ZONE,
            weekday: 'long'
        }).format(this.shipDate);
        const shipMonthName = new Intl.DateTimeFormat('en-US', {
            timeZone: ProductPageOrderDeadline.STORE_TIME_ZONE,
            month: 'long'
        }).format(this.shipDate);
        const shipDay = Number(shipDateParts.day);

        this.renderedShipDateString = `Ships ${shipWeekdayName}, ${shipDay}${getDateSuffix(shipDay)} ${shipMonthName}`;
    }

    getStoreDateParts(date) {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: ProductPageOrderDeadline.STORE_TIME_ZONE,
            weekday: 'short',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hourCycle: 'h23'
        }).formatToParts(date);

        return Object.fromEntries(
            parts
                .filter(part => part.type !== 'literal')
                .map(part => [part.type, part.value])
        );
    }

    getStoreTimeZoneOffset(date) {
        const parts = this.getStoreDateParts(date);
        const representedAsUtc = Date.UTC(
            Number(parts.year),
            Number(parts.month) - 1,
            Number(parts.day),
            Number(parts.hour),
            Number(parts.minute),
            Number(parts.second)
        );

        return representedAsUtc - date.getTime();
    }

    storeDateToInstant(year, month, day, hour = 0, minute = 0) {
        const approximate = Date.UTC(year, month - 1, day, hour, minute);
        let result = approximate - this.getStoreTimeZoneOffset(new Date(approximate));

        // Recalculate once in case the first estimate crossed a daylight-saving boundary.
        result = approximate - this.getStoreTimeZoneOffset(new Date(result));
        return new Date(result);
    }

    getStoreWeekdayInCurrentWeek(weekday, hour, referenceDate) {
        const parts = this.getStoreDateParts(referenceDate);
        const storeToday = new Date(Date.UTC(
            Number(parts.year),
            Number(parts.month) - 1,
            Number(parts.day)
        ));
        const currentWeekday = storeToday.getUTCDay() || 7;
        const dayOffset = weekday - currentWeekday;

        storeToday.setUTCDate(storeToday.getUTCDate() + dayOffset);
        return this.storeDateToInstant(
            storeToday.getUTCFullYear(),
            storeToday.getUTCMonth() + 1,
            storeToday.getUTCDate(),
            hour
        );
    }

    getNextStoreWeekday(weekday, hour, referenceDate) {
        let candidate = this.getStoreWeekdayInCurrentWeek(weekday, hour, referenceDate);
        if (candidate <= referenceDate) candidate = this.addStoreCalendarDays(candidate, 7);
        return candidate;
    }

    addStoreCalendarDays(date, days) {
        const parts = this.getStoreDateParts(date);
        const calendarDate = new Date(Date.UTC(
            Number(parts.year),
            Number(parts.month) - 1,
            Number(parts.day) + days
        ));

        return this.storeDateToInstant(
            calendarDate.getUTCFullYear(),
            calendarDate.getUTCMonth() + 1,
            calendarDate.getUTCDate(),
            Number(parts.hour),
            Number(parts.minute)
        );
    }

    renderHtmlElements(cutoffDateText, shipDateText) { 
      this.cutoffDateElement.textContent = cutoffDateText || '';
      this.shipDateElement.textContent = shipDateText || '';
    }

    setCartAttribute(orderShipDateText) {
      try {
        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            attributes: {
              'order-ship-date': orderShipDateText,
            },
          }),
        })
      } catch (error) {
        console.error("Failed to set cart attribute:", error);
        this.renderHtmlElements('', '');
      }
    }

}

if (!customElements.get('product-page-order-deadline')) {
  customElements.define('product-page-order-deadline', ProductPageOrderDeadline);
}

///////////////////////////////////////////////////////////////////////////////

class ColorCollectionPageNav extends HTMLElement {
  constructor() { super(); }
  connectedCallback() {
    this.leftButton = this.querySelector('.scrollable-navigation-button--left');
    this.rightButton = this.querySelector('.scrollable-navigation-button--right');
    this.navMenu = this.querySelector('.lace-colors-nav-list');
    const _boundLeftClick = this.scrollLeft.bind(this);
    const _boundRightClick = this.scrollRight.bind(this);
    this.leftButton.addEventListener('click', _boundLeftClick);
    this.rightButton.addEventListener('click', _boundRightClick);
    this.updateButtonVisibility();
    const _boundUpdateVisibility = this.updateButtonVisibility.bind(this);
    this.navMenu.addEventListener('scroll', _boundUpdateVisibility);
    window.addEventListener('resize', _boundUpdateVisibility);
    // for a tag in this.navMenu, add click event to do the function on handleLinkItemClick
    const linkItems = this.navMenu.querySelectorAll('li');
    linkItems.forEach((item) => {
      const _boundLinkClick = this.handleLinkItemClick.bind(this);
      item.addEventListener('click', _boundLinkClick);
    });
  }
  disconnectedCallback() {
    this.leftButton.removeEventListener('click', this._boundLeftClick);
    this.rightButton.removeEventListener('click', this._boundRightClick);
    this.navMenu.removeEventListener('scroll', this._boundUpdateVisibility);
    window.removeEventListener('resize', this._boundUpdateVisibility);
    linkItems.forEach((item) => {
      item.removeEventListener('click', _boundLinkClick);
    });
  }
  scrollLeft() { this.navMenu.scrollBy({ left: -200, behavior: 'smooth' }); }
  scrollRight() { this.navMenu.scrollBy({ left: 200, behavior: 'smooth' }); }
  updateButtonVisibility() {
    const showLeft = this.navMenu.scrollLeft > 0;
    const showRight = this.navMenu.scrollLeft + this.navMenu.clientWidth < this.navMenu.scrollWidth;
    const showBoth = showLeft || showRight;
    this.leftButton.style.display = showBoth ? 'flex' : 'none';
    this.rightButton.style.display = showBoth ? 'flex' : 'none';
  }
  resetNavEls() {
    const navEls = this.navMenu.querySelectorAll('li');
    navEls.forEach(el => { el.classList.remove('active'); });
  }
  handleLinkItemClick(event) {
    event.preventDefault();
    this.resetNavEls();
    event.target.classList.add('active');
    const selected = event.target.dataset.materialNav;
    document.querySelectorAll('[data-material]').forEach(el => {
      if(selected == 'all') el.style.display = 'block';
      else {
        if(selected == el.dataset.material) el.style.display = 'block';
        else el.style.display = 'none';
      }
    });
  }
}
if (!customElements.get('color-collection-page-nav')) {
  customElements.define('color-collection-page-nav', ColorCollectionPageNav);
}


class CollectionPageNav extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.bannerSectionId = document.querySelector('.main-collection-banner').id.replace('shopify-section-', '') || null;

    this.leftButton = this.querySelector('.scrollable-navigation-button--left');
    this.rightButton = this.querySelector('.scrollable-navigation-button--right');
    this.navMenu = this.querySelector('.collection-page-menu');
    const _boundLeftClick = this.scrollLeft.bind(this);
    const _boundRightClick = this.scrollRight.bind(this);
    this.leftButton.addEventListener('click', _boundLeftClick);
    this.rightButton.addEventListener('click', _boundRightClick);
    this.updateButtonVisibility();
    const _boundUpdateVisibility = this.updateButtonVisibility.bind(this);
    this.navMenu.addEventListener('scroll', _boundUpdateVisibility);
    window.addEventListener('resize', _boundUpdateVisibility);

    // for a tag in this.navMenu, add click event to do the function on handleLinkItemClick
    const linkItems = this.navMenu.querySelectorAll('a.collection-page-menu-link');
    linkItems.forEach((item) => {
      const _boundLinkClick = this.handleLinkItemClick.bind(this);
      item.addEventListener('click', _boundLinkClick);
    });
  }

  disconnectedCallback() {
    this.leftButton.removeEventListener('click', this._boundLeftClick);
    this.rightButton.removeEventListener('click', this._boundRightClick);
    this.navMenu.removeEventListener('scroll', this._boundUpdateVisibility);
    window.removeEventListener('resize', this._boundUpdateVisibility);
    linkItems.forEach((item) => {
      item.removeEventListener('click', _boundLinkClick);
    });
  }

  scrollLeft() {
    this.navMenu.scrollBy({ left: -200, behavior: 'smooth' });
  }

  scrollRight() {
    this.navMenu.scrollBy({ left: 200, behavior: 'smooth' });
  }

  updateButtonVisibility() {
    const showLeft = this.navMenu.scrollLeft > 0;
    const showRight = this.navMenu.scrollLeft + this.navMenu.clientWidth < this.navMenu.scrollWidth;
    const showBoth = showLeft || showRight;
    
    this.leftButton.style.display = showBoth ? 'flex' : 'none';
    this.rightButton.style.display = showBoth ? 'flex' : 'none';
  }

  updateCurrentLinkHighlight(url) {
    const linkItems = this.navMenu.querySelectorAll('a.collection-page-menu-link');
    linkItems.forEach((item) => {
      if (new URL(item.href).pathname === url.pathname) {
        item.classList.add('current-collection-page');
      } else {
        item.classList.remove('current-collection-page');
      }
    });
  }

  handleLinkItemClick(event) {
    event.preventDefault();

    // get current url parameters
    const currentParams = new URLSearchParams(window.location.search);
    const url = new URL(event.currentTarget.href);
    
    currentParams.forEach((value, key) => {
      if(!event.target.classList.contains('collection-page-menu-link')) {
        url.searchParams.set(key, value);
      }
    });
    
    if (this.bannerSectionId) {
      url.searchParams.set('sections', `${this.sectionId},${this.bannerSectionId}`);
    } else {
      url.searchParams.set('sections', this.sectionId);
    }

    //path name with search params
    const pathWithParams = `${url.pathname}${url.search}`;

    fetch(pathWithParams)
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      if (this.bannerSectionId) {
        const tempDivForHeader = document.createElement('div');
        tempDivForHeader.innerHTML = data[this.bannerSectionId];
        const bannerToReplace = document.querySelector('#element-main-collection-banner');
        if (bannerToReplace) {
          document.querySelector('#element-main-collection-banner').innerHTML = tempDivForHeader.querySelector('#element-main-collection-banner').innerHTML;
        } else {
          window.location.replace(url.pathname);
        }
      }

      const tempDivForGrid = document.createElement('div');
      tempDivForGrid.innerHTML = data[this.sectionId];
      document.querySelector('#CollectionProductGrid').innerHTML = tempDivForGrid.querySelector('#CollectionProductGrid').innerHTML;
      // Update URL without adding to history
      window.history.replaceState({}, '', url.pathname + window.location.search);
      this.updateCurrentLinkHighlight(url); 
      StampedFn?.loadBadges();  
    })
    .catch((error) => {
      console.error('Error fetching collection data:', error);
    });
  }

}
if (!customElements.get('collection-page-nav')) {
  customElements.define('collection-page-nav', CollectionPageNav);
}

///////////////////////////////////////////////////////////////////////////////

class BlogPageNav extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;

    this.leftButton = this.querySelector('.scrollable-navigation-button--left');
    this.rightButton = this.querySelector('.scrollable-navigation-button--right');
    this.navMenu = this.querySelector('.blog-page-menu');
    const _boundLeftClick = this.scrollLeft.bind(this);
    const _boundRightClick = this.scrollRight.bind(this);
    this.leftButton.addEventListener('click', _boundLeftClick);
    this.rightButton.addEventListener('click', _boundRightClick);
    this.updateButtonVisibility();
    const _boundUpdateVisibility = this.updateButtonVisibility.bind(this);
    this.navMenu.addEventListener('scroll', _boundUpdateVisibility);
    window.addEventListener('resize', _boundUpdateVisibility);

    // for a tag in this.navMenu, add click event to do the function on handleLinkItemClick
    const linkItems = this.navMenu.querySelectorAll('a.blog-page-menu-link');
    linkItems.forEach((item) => {
      const _boundLinkClick = this.handleLinkItemClick.bind(this);
      item.addEventListener('click', _boundLinkClick);
    });
  }

  disconnectedCallback() {
    this.leftButton.removeEventListener('click', this._boundLeftClick);
    this.rightButton.removeEventListener('click', this._boundRightClick);
    this.navMenu.removeEventListener('scroll', this._boundUpdateVisibility);
    window.removeEventListener('resize', this._boundUpdateVisibility);
    linkItems.forEach((item) => {
      item.removeEventListener('click', _boundLinkClick);
    });
  }

  scrollLeft() {
    this.navMenu.scrollBy({ left: -200, behavior: 'smooth' });
  }

  scrollRight() {
    this.navMenu.scrollBy({ left: 200, behavior: 'smooth' });
  }

  updateButtonVisibility() {
    const showLeft = this.navMenu.scrollLeft > 0;
    const showRight = this.navMenu.scrollLeft + this.navMenu.clientWidth < this.navMenu.scrollWidth;
    const showBoth = showLeft || showRight;
    
    this.leftButton.style.display = showBoth ? 'flex' : 'none';
    this.rightButton.style.display = showBoth ? 'flex' : 'none';
  }

  updateCurrentLinkHighlight(url) {
    const linkItems = this.navMenu.querySelectorAll('a.blog-page-menu-link');
    linkItems.forEach((item) => {
      if (new URL(item.href).pathname === url.pathname) {
        item.classList.add('current-blog-page');
      } else {
        item.classList.remove('current-blog-page');
      }
    });
  }

  handleLinkItemClick(event) {
    event.preventDefault();

    // get current url parameters
    const url = new URL(event.currentTarget.href);
    url.searchParams.set('sections', this.sectionId);

    fetch(url)
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = data[this.sectionId];
      document.querySelector('#mainBlogContainer').innerHTML = tempDiv.querySelector('#mainBlogContainer').innerHTML;
      // Update URL without adding to history
      window.history.replaceState({}, '', url.pathname + window.location.search); 
      this.updateCurrentLinkHighlight(url);     
    })
    .catch((error) => {
      console.error('Error fetching collection data:', error);
    });
  }

}
if (!customElements.get('blog-page-nav')) {
  customElements.define('blog-page-nav', BlogPageNav);
}

///////////////////////////////////////////////////////////////////////////////

class MMInCartAddOns extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    this.selectElement = this.querySelector('select[name="id"]') || null;
    this.addButton = this.querySelector('button[type="submit"]') || null;
    this.hiddenInput = this.querySelector('input[type="hidden"][name="id"]') || null;

    if(this.selectElement) {
      this._boundHandleSelectChange = this.handleSelectChange.bind(this);
      this.selectElement.addEventListener('change', this._boundHandleSelectChange);
    }

    if(this.addButton) {
      this._boundHandleAddButtonClick = this.handleAddButtonClick.bind(this);
      this.addButton.addEventListener('click', this._boundHandleAddButtonClick);
    }

    this._boundRefreshAddOnSection = this.refreshAddOnSection.bind(this);
    document.addEventListener('add-to-cart', this._boundRefreshAddOnSection);
    document.addEventListener('cart-updated', this._boundRefreshAddOnSection);

  }

  disconnectedCallback() {
    if(this.selectElement) {
      this.selectElement.removeEventListener('change', this._boundHandleSelectChange);
    }
    if(this.addButton) {
      this.addButton.removeEventListener('click', this._boundHandleAddButtonClick);
    }
    document.removeEventListener('add-to-cart', this._boundRefreshAddOnSection);
    document.removeEventListener('cart-updated', this._boundRefreshAddOnSection);
  }

  handleSelectChange(event) {
    if (!event.target.value) {
      this.hiddenInput.value = '';
    } else {
      this.hiddenInput.value = event.target.value;
      this.selectImageAndPrice(event.target.value);
    }
  }

  async handleAddButtonClick(event) {
    event.preventDefault();
    this.addButton.classList.add('processing');
    this.addButton.setAttribute('disabled', 'disabled');

    if (!this.hiddenInput.value) {
      alert('Select an option.');
    } else {

      try {
        let formData = {
        'items': [{
          'id': this.hiddenInput.value,
          'quantity': 1
          }]
        };

        await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        let addToCartEvent = new Event('add-to-cart', { bubbles: true } );
        this.dispatchEvent(addToCartEvent);
        
      } catch (error) {
        console.error("Error:", error);
      }
    }

    // wait 1 second to show processing state
    await new Promise(resolve => setTimeout(resolve, 1000));
    if(!this.addButton) return;
    this.addButton.classList.remove('processing');
    this.addButton.removeAttribute('disabled'); 
  }

  selectImageAndPrice(variantId) {
    const imageElements = this.querySelectorAll('[data-associated-variant-id]');
    imageElements.forEach((el) => {
      const imageVariantId = el.getAttribute('data-associated-variant-id');      
      if (Number(imageVariantId) === Number(variantId)) {
        // if image is type div, remove hidden class,
        // if it is image, remove hidden from parent figure
        if (el.tagName.toLowerCase() === 'img') {
          el.parentElement.classList.remove('hidden');
        } else {
          el.classList.remove('hidden');
        }
      } else {
        if (el.tagName.toLowerCase() === 'img') {
          el.parentElement.classList.add('hidden');
        } else {
          el.classList.add('hidden');
        }
      }
    });
  }

  async refreshAddOnSection() {
    await fetch('/?section_id=mm-cart-add-ons-srapi')
      .then((response) => response.text())
      .then((text) => {
        const sectionHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('mm-in-cart-add-ons').innerHTML || null;
        this.innerHTML = sectionHTML;

        this.disconnectedCallback();
        this.connectedCallback();
      });
  }

}
if (!customElements.get('mm-in-cart-add-ons')) {
  customElements.define('mm-in-cart-add-ons', MMInCartAddOns);
}


document.addEventListener('DOMContentLoaded', (event) => {
  const is_iOS = ( navigator.userAgent.match(/(iPad|iPhone|iPod)/i) ? true : false );
  const is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
  const is_android = ( navigator.userAgent.match(/(android)/i) ? true : false );

  if(is_iOS) document.body.classList.add('iOS');
  if(is_safari) document.body.classList.add('safari');
  if(is_android) document.body.classList.add('android');
  
  document.body.classList.add(window.screen.width + 'x' + window.screen.height);

});
